module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Stwórz szablon\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.templates.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć do szablonów")])], 1), _vm._v(" "), _c('templates-form', {
    attrs: {
      "item": _vm.item
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1e071e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/Create.vue
// module id = 280
// module chunks = 0